import React from "react";
import GoogleMapReact from "google-map-react";
import PropTypes from "prop-types";
const AnyReactComponent = () => (
  <i className="marker material-icons">location_on</i>
);

const Map = ({ lat, lng }) => {
  const keyApiGoogleMaps = process.env.REACT_APP_API_KEY_MAP || "";
  const center = [parseInt(lat), parseInt(lng)];

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: keyApiGoogleMaps }}
      defaultCenter={center}
      defaultZoom={13}
    >
      <AnyReactComponent lat={parseInt(lat)} lng={parseInt(lng)} />
    </GoogleMapReact>
  );
};

export default Map;

Map.propTypes = {
  lat: PropTypes.string,
  lng: PropTypes.string
};
